import React from "react";
import tag from "./styles/consultationStatusTags.module.css";

function StatusChip({ variant, children }) {
    const variants = {
        muted: tag.tagMuted,
        neutral: tag.tagNeutral,
        warning: tag.tagWarning,
        success: tag.tagSuccess,
        danger: tag.tagDanger,
        info: tag.tagInfo,
        orange: tag.tagOrange,
    };
    return (
        <span className={`${tag.tag} ${variants[variant] || tag.tagNeutral}`}>{children}</span>
    );
}

function evalToString(str) {
    switch (str) {
        case -1:
            return <StatusChip variant="muted">Cargando...</StatusChip>;
        case 0:
            return <StatusChip variant="muted">Pendiente</StatusChip>;
        case 1:
            return <StatusChip variant="warning">Observado</StatusChip>;
        case 2:
            return <StatusChip variant="success">Aceptado</StatusChip>;
        case 3:
            return <StatusChip variant="danger">Rechazado</StatusChip>;
        case 4:
            return <StatusChip variant="info">Pre-aprobado</StatusChip>;
        default:
            return <StatusChip variant="muted">Pendiente</StatusChip>;
    }
}

function sunatToString(str) {
    switch (str) {
        case -1:
            return <StatusChip variant="muted">Cargando...</StatusChip>;
        case '01':
            return <StatusChip variant="muted">Pendiente</StatusChip>;
        case '03':
            return <StatusChip variant="warning">Subsanado</StatusChip>;
        case '04':
            return <StatusChip variant="success">Conforme</StatusChip>;
        case '02':
            return <StatusChip variant="danger">Disconforme</StatusChip>;
        case '05':
            return <StatusChip variant="danger">No válido</StatusChip>;
        case '06':
            return <StatusChip variant="muted">Pendiente</StatusChip>;
        default:
            return <StatusChip variant="muted">Pendiente</StatusChip>;
    }
}

function oseSunatToString(str) {
    switch (str) {
        case -1:
            return <StatusChip variant="muted">Cargando...</StatusChip>;
        case '0':
            return <StatusChip variant="neutral">No existe</StatusChip>;
        case '1':
            return <StatusChip variant="success">Aceptado</StatusChip>;
        case '2':
            return <StatusChip variant="danger">Anulado</StatusChip>;
        case '3':
            return <StatusChip variant="success">Autorizado</StatusChip>;
        case '4':
            return <StatusChip variant="danger">No autorizado</StatusChip>;
        default:
            return <StatusChip variant="muted">Pendiente</StatusChip>;
    }
}

function statusToString(row, data) {
    switch (data) {
        case -1:
            return <StatusChip variant="muted">Cargando...</StatusChip>;
        case 0:
            return <StatusChip variant="muted">Pendiente</StatusChip>;
        case 1:
            return <StatusChip variant="warning">Observado</StatusChip>;
        case 2:
            return <StatusChip variant="success">Completado</StatusChip>;
        case 3:
            return <StatusChip variant="orange">En revisión</StatusChip>;
        case 4:
            return <StatusChip variant="info">Parcial</StatusChip>;
        default:
            return <StatusChip variant="muted">Pendiente</StatusChip>;
    }
}

function pendingInvoicesToString(row, data) {
    if (data === true) {
        return <StatusChip variant="orange">Por atender</StatusChip>;
    }
    if (data === false) {
        return <StatusChip variant="success">Atendido</StatusChip>;
    }
    return <StatusChip variant="muted">—</StatusChip>;
}

function financingStatusToString(data) {
    switch (data) {
        case 0:
            return <StatusChip variant="muted">Sin solicitar…</StatusChip>;
        case 1:
            return <StatusChip variant="success">Solicitado</StatusChip>;
        default:
            return null;
    }
}

function formatTimestamp(timestamp) {
    if (timestamp == null) return "-";
    const date = new Date(timestamp);
    return date.toLocaleString();
}

function pagoToString(str) {
    if (str === 0) {
        return <StatusChip variant="muted">Pendiente</StatusChip>;
    }
    return <StatusChip variant="success">Recibido</StatusChip>;
}

export {
    sunatToString,
    oseSunatToString,
    evalToString,
    statusToString,
    formatTimestamp,
    pagoToString,
    financingStatusToString,
    pendingInvoicesToString,
    StatusChip,
};
